import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledUserLectures = styled.div`
  .page-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    letter-spacing: 0px;
    vertical-align: middle;
    margin-bottom: 46px;
  }

  .search-wrapper {
    display: flex;
    margin-bottom: 20px;

    .ant-form {
      display: flex;
      gap: 4px;
    }

    .ant-input-affix-wrapper {
      border-radius: 4px;
    }

    .search-btn {
      width: 80px;
      height: 40px;
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      color: #fff;
      background-color: #102861;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: #0c204d;
      }

      &:active {
        background-color: #091738;
      }
    }
  }
`;

export const StyledSortTableHeader = styled.div`
  user-select: none;
  display: flex;
  justify-content: space-between;

  p {
    margin-bottom: 0;
    flex: auto;
  }

  align-items: center;
`;

export const StyledLectureStudentsModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-close-x {
    display: flex;
    justify-content: center;
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;
